'use strict';

import { reverseUrl } from 'utils/django';
import { userNameCmp } from 'users/utils';


export default function($http) {
	'ngInject';

	var url = reverseUrl('entities:entity');
	return $http.get(url).then(function(response) {
		var userList = [];
		response.data.roles.forEach(function(role) {
			if (role.display_name == '_Staff') {
				return;
			}
			role.users.forEach(function(user) {
				if (!user.is_active) {
					return;
				}
				user.role = role.display_name;
				userList.push(user);
			});
		});
		userList.sort(userNameCmp);
		return userList;
	});
}
